import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Unauthorized } from './pages/Unauthorized';
import SessionExpired from './pages/SessionExpired';
import { BookOnlineRoutes } from './routes/BookOnlineRoutes';
import { DevModeRibbon } from './components/DevModeRibbon';
import { usePracticeBranding } from './hooks/usePracticeBranding';
import { useCurveTracking } from './hooks/useCurveTracking';

function App() {
  usePracticeBranding();
  useCurveTracking();

  return (
    <>
      <DevModeRibbon />

      <Routes>
        <Route path="unauthorized" element={<Unauthorized />} />
        <Route path="session-expired" element={<SessionExpired />} />

        {/* Scheduler: practice booking */}
        <Route path=":practiceId" element={<Landing />} />
        <Route path=":practiceId/bookonline/*" element={<BookOnlineRoutes />} />

        <Route path="*" element={<Navigate to="/unauthorized" replace />} />
      </Routes>
    </>
  );
}

export default App;
